import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import Container from '@ep/components/Container';
import Flex from '@ep/components/Flex';
import ContentLightBox from '@ep/components/NewContentLightBox';
import { H2 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_RichText } from '@ep/types/gatsbyTypes';
import { navigate } from 'gatsby';
import React from 'react';

export interface HeroCTABarModuleProps {
  title: string;
  ctaLabel: string;
  ctaLink: string;
  ctaModalText: Gcms_RichText;
  ctaModalButtonLabel: string;
  ctaModalButtonLink: string;
}

const BlueBar = styled.div`
  background-color: ${theme.colors.duskBlue};
  width: 100%;
`;

const StyledContainer = styled(Container)`
  display: flex;
  padding: 1.3rem 2rem 1.3rem 0.5rem;
  background-color: ${theme.colors.duskBlue};
  justify-content: space-between;

  ${theme.mediaQueries.tablet} {
    padding: 1rem 3.5rem;
  }
  ${theme.mediaQueries.mobile} {
    padding: 1rem 1.5rem;
    flex-direction: column;
  }
`;

const Title = styled(H2)`
  color: ${theme.colors.white};
  margin: 0;
  padding-right: 4rem;
  line-height: 1;
`;

const HeroButton = styled(Button)`
  font-size: 1.2rem;
  line-height: 1;
  ${theme.mediaQueries.mobileAndTablet} {
    margin-top: 1rem;
    justify-content: center;
  }
`;

const HeroCTABarModule = ({
  title,
  ctaLabel,
  ctaLink,
  ctaModalButtonLabel,
  ctaModalButtonLink,
  ctaModalText,
}: HeroCTABarModuleProps) => {
  const [open, setOpen] = React.useState(false);

  // tslint:disable-next-line: no-floating-promises
  const redirectToPage = (link: string) => navigate(link);

  const handleButtonClick = () => {
    if (Boolean(ctaModalText) && ctaModalText.html !== '<p></p>') {
    //if (Boolean(ctaModalText)) {
      setOpen(true);
    } else {
      // tslint:disable-next-line: no-floating-promises
      redirectToPage(ctaLink);
    }
  };

  return (
    <BlueBar>
      <StyledContainer>
        <Title>{title}</Title>
        <HeroButton onClick={handleButtonClick}>{ctaLabel}</HeroButton>
        <ContentLightBox
          openLightBox={open}
          setOpenLightBox={() => setOpen(false)}
          contentLightBoxText={ctaModalText}
        >
          <Flex style={{ justifyContent: 'flex-end' }}>
            <Button
              onClick={() => {
                // tslint:disable-next-line: no-floating-promises
                redirectToPage(ctaModalButtonLink);
                setOpen(false);
              }}
            >
              {ctaModalButtonLabel}
            </Button>
          </Flex>
        </ContentLightBox>
      </StyledContainer>
    </BlueBar>
  );
};

export default HeroCTABarModule;
